module.exports = __webpack_public_path__ + "img/top-section-mobile.b26d2af5.webp";